import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { IInfo, IMerchant } from "@interfaces";
import { Dispatch, SetStateAction } from "react";
import { IconPoint } from "../icon/Point";

function formatDateNumber(date: any) {
    let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day + "/" + month + "/" + year].join(" ");
}

const Card = ({
    userInfo,
    merchant,
    setCurrentIndex,
}: {
    merchant: IMerchant;
    userInfo: IInfo | null;
    setCurrentIndex: Dispatch<SetStateAction<number>>;
}) => {
    const onSlideChange2 = (e: any) => {
        setCurrentIndex(e.activeIndex as number);
    };

    return (
        <Swiper slidesPerView={1.1} onSlideChange={onSlideChange2} pagination={true}>
            {merchant?.memberShipTiers?.map((item: any, index: any) => (
                <SwiperSlide key={index}>
                    <div className="layout-main-detail-card">
                        <div className="layout-card-membercard">
                            <img src={item.benefitCardImage} alt="imgmemberdetail" />
                            {userInfo?.memberTier?.tierName === item.membershipName && (
                                <div className="current-card-membercard">Current tier</div>
                            )}
                            <div
                                className="text-card-membercard"
                                style={{ color: item.textOverlayColor || "#000" }}
                            >
                                <div className="tier-card-membercard">{item.membershipName}</div>
                                <div
                                    className="valid-card-membercard"
                                    style={{ color: item.textOverlayColor || "#000" }}
                                >
                                    Member Since : {formatDateNumber(userInfo?.createdAt)}
                                </div>
                                {merchant?.securityConfig?.isPointDisplay && (
                                    <div
                                        className="point-card-membercard"
                                        style={{ color: item.textOverlayColor || "#000" }}
                                    >
                                        {userInfo?.totalPoints}
                                        <span>
                                            <IconPoint />
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default Card;

const CardContainer = styled.div`
    width: 300px;
    height: 300px;
    background-color: red;
`;
